
import React from 'react';
import { Redirect } from 'react-router';

const HomePage = (props) => {
    return <Redirect to="/projectlist" />;
}

export default HomePage;
